export default __webpack_public_path__ + "static/media/bootstrap.333f5e43.svg";